import { z } from "zod";
export const LegalReadinessRegistryV1Schema = z
    .object({
    schemaVersion: z.literal("legal-readiness-registry.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalLegalReadinessRegistry(recordedAt) {
    return LegalReadinessRegistryV1Schema.parse({
        schemaVersion: "legal-readiness-registry.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=legal-readiness-registry.js.map